import {
  BookkeepingTagNavItemValue,
  getAccountFromBookkeepingTagAnswer,
  getTaxRateFromBookkeepingTagAnswer,
} from '@components'

import { Contact } from '@features/contacts/types/contact'
import { Account } from '@modules-deprecated/app/accounts/types'
import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { getRegion } from '../../../../../utils/getRegion'

interface GetDataFromBookkeepingTagProps {
  accounts?: Account[]
  bookkeepingTagValue: BookkeepingTagNavItemValue
  hasVATdetected: boolean | undefined
  organizationCountryCode?: string
  taxRates?: TaxRate[]
  vendor?: Partial<Contact>
}

interface GetDataFromBookkeepingTagResult {
  account: Account | undefined
  taxRate: TaxRate | undefined
}

export const getDataFromBookkeepingTag = ({
  accounts,
  bookkeepingTagValue,
  hasVATdetected,
  organizationCountryCode,
  taxRates,
  vendor,
}: GetDataFromBookkeepingTagProps): GetDataFromBookkeepingTagResult => {
  const countryId = vendor?.country?.id || vendor?.countryId
  const contactCountryId = countryId
  const region = getRegion({ vendorCountryCode: contactCountryId, organizationCountryCode })
  const answer = bookkeepingTagValue.response

  const account = answer ? getAccountFromBookkeepingTagAnswer(answer.accountId, accounts) : undefined
  const taxRate =
    answer && taxRates
      ? getTaxRateFromBookkeepingTagAnswer({ answer: answer.vatRates, hasVATdetected, taxRates, region })
      : undefined

  return {
    account,
    taxRate,
  }
}
